import { render, staticRenderFns } from "./extrato.vue?vue&type=template&id=38a97384&"
import script from "./extrato.vue?vue&type=script&lang=js&"
export * from "./extrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports